import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const money = (n) =>
  `${Number(n) < 0 ? "-" : ""}$${Math.abs(Number(n || 0)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const bankAbbr = (name) =>
  ({ "Bank of America": "BofA", "American Express": "Amex", "Capital One": "CapOne", "Wells Fargo": "Wells" })[name] || name;

export const shortDate = (iso) =>
  iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";

export const STATUS_STYLE = {
  needs_response: "text-[#FFB800] border-[#FFB800]/40 bg-[#FFB800]/10",
  under_review: "text-accent2 border-accent2/40 bg-accent2/10",
  won: "text-brand border-brand/40 bg-brand/10",
  lost: "text-[#F87171] border-[#F87171]/40 bg-[#F87171]/10",
  accepted: "text-white/45 border-[#2A3735] bg-white/5",
};

export const riskColor = (s) => (s >= 50 ? "#F87171" : s >= 20 ? "#FFB800" : "#CCFF00");

export const EVIDENCE_TYPES = [
  "login", "content_access", "file_download", "submission", "delivery",
  "email_confirmation", "device_fingerprint", "payment_auth", "consent", "video_verification", "video_transcript",
];
